import { APIErrorMessages } from '@/utils/APIErrorMessages'

export const showAPIValidatorErrors =  (errors = [], title = 'Atenção') => {

        objSwal.error.title = title

        Swal.fire(objSwal.error).then(turnAround => turnAround)

        let list = document.createElement('ul')

        for (const error of errors) {
          let item = document.createElement('li')

          item.innerText = APIErrorMessages[error.field] || APIErrorMessages['default']

          list.appendChild(item)
        }

        objSwal.error.html = list

        Swal.fire(objSwal.error).then(turnAround => turnAround)
      }